module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Blender-2734dadf0d37f241aa1284198a6299f1.svg";